import {matchPath} from "react-router";
import * as pathToRegexp from "path-to-regexp";

import {prefixPath} from "@pg-mono/prefix-path";

import {SiteSlug} from "./types/site_slug";

export const kmAppPath = prefixPath("/", {
    base: "",
    logout: "logout/",
    site: prefixPath(":site([\\w-]+)/", {
        base: "",
        landingPage: prefixPath("", {
            createAccount: "nowe-konto/"
        }),
        messages: prefixPath("wiadomosci/", {
            base: ""
        }),
        offers: prefixPath("oferty/", {
            base: "",
            favourites: "ulubione/",
            applied: "moje-zapytania/",
            dismissed: "odrzucone/",
            messages: "wiadomosci/"
        }),
        passwordChange: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        remindPassword: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        unsubscribe: prefixPath("unsubscribe/", {
            cpl: "cpl/:uuid/",
            mailing: "mailing/:emailHash/:verificationHash/"
        }),
        user: prefixPath("konto/", {
            base: "",
            edit: "edycja/",
            passwordChange: "zmien-haslo/",
            subscription: "subskrypcje/",
            marketingConsent: "zgody-marketingowe/",
            preferences: "preferencje/",
            test: "test/"
        })
    }),
    unsubscribeHM: "unsubscribe/hm/:login_token/"
});

export const kmAppLink = {
    logout: noParamsLink(kmAppPath.logout), // logout is handled on backend, routed with ingress
    site: {
        base: noParamsLink(kmAppPath.site.base),
        baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.base),
        messages: parseParams<{site: SiteSlug}>(kmAppPath.site.messages.base),
        offers: {
            base: noParamsLink(kmAppPath.site.offers.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.base),
            // recommendedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.recommended),
            favouritesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.favourites),
            appliedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.applied),
            dismissedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.dismissed)
        },
        passwordChange: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.passwordChange.link)
        },
        remindPassword: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.remindPassword.link)
        },
        user: {
            base: noParamsLink(kmAppPath.site.user.edit),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            edit: noParamsLink(kmAppPath.site.user.edit),
            editWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            passwordChange: noParamsLink(kmAppPath.site.user.passwordChange),
            passwordChangeWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.passwordChange),
            subscription: noParamsLink(kmAppPath.site.user.subscription),
            subscriptionWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.subscription),
            marketingConsent: noParamsLink(kmAppPath.site.user.marketingConsent),
            marketingConsentWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.marketingConsent),
            preferences: noParamsLink(kmAppPath.site.user.preferences),
            preferencesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.preferences)
        }
    }
};

function parseParams<T extends {}>(path: string) {
    const compiler = pathToRegexp.compile(path);
    return (params: T) => compiler(params);
}

function noParamsLink(path: string) {
    const compiler = pathToRegexp.compile(path);
    return () => {
        const matchedSite = matchPath<{site: SiteSlug}>(window.location.pathname, {path: kmAppPath.site.base})?.params.site;
        return compiler({site: matchedSite});
    };
}
import {matchPath} from "react-router";
import * as pathToRegexp from "path-to-regexp";

import {prefixPath} from "@pg-mono/prefix-path";

import {SiteSlug} from "./types/site_slug";

export const kmAppPath = prefixPath("/", {
    base: "",
    logout: "logout/",
    site: prefixPath(":site([\\w-]+)/", {
        base: "",
        landingPage: prefixPath("", {
            createAccount: "nowe-konto/"
        }),
        messages: prefixPath("wiadomosci/", {
            base: ""
        }),
        offers: prefixPath("oferty/", {
            base: "",
            favourites: "ulubione/",
            applied: "moje-zapytania/",
            dismissed: "odrzucone/",
            messages: "wiadomosci/"
        }),
        passwordChange: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        remindPassword: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        unsubscribe: prefixPath("unsubscribe/", {
            cpl: "cpl/:uuid/",
            mailing: "mailing/:emailHash/:verificationHash/"
        }),
        user: prefixPath("konto/", {
            base: "",
            edit: "edycja/",
            passwordChange: "zmien-haslo/",
            subscription: "subskrypcje/",
            marketingConsent: "zgody-marketingowe/",
            preferences: "preferencje/",
            test: "test/"
        })
    }),
    unsubscribeHM: "unsubscribe/hm/:login_token/"
});

export const kmAppLink = {
    logout: noParamsLink(kmAppPath.logout), // logout is handled on backend, routed with ingress
    site: {
        base: noParamsLink(kmAppPath.site.base),
        baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.base),
        messages: parseParams<{site: SiteSlug}>(kmAppPath.site.messages.base),
        offers: {
            base: noParamsLink(kmAppPath.site.offers.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.base),
            // recommendedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.recommended),
            favouritesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.favourites),
            appliedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.applied),
            dismissedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.dismissed)
        },
        passwordChange: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.passwordChange.link)
        },
        remindPassword: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.remindPassword.link)
        },
        user: {
            base: noParamsLink(kmAppPath.site.user.edit),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            edit: noParamsLink(kmAppPath.site.user.edit),
            editWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            passwordChange: noParamsLink(kmAppPath.site.user.passwordChange),
            passwordChangeWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.passwordChange),
            subscription: noParamsLink(kmAppPath.site.user.subscription),
            subscriptionWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.subscription),
            marketingConsent: noParamsLink(kmAppPath.site.user.marketingConsent),
            marketingConsentWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.marketingConsent),
            preferences: noParamsLink(kmAppPath.site.user.preferences),
            preferencesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.preferences)
        }
    }
};

function parseParams<T extends {}>(path: string) {
    const compiler = pathToRegexp.compile(path);
    return (params: T) => compiler(params);
}

function noParamsLink(path: string) {
    const compiler = pathToRegexp.compile(path);
    return () => {
        const matchedSite = matchPath<{site: SiteSlug}>(window.location.pathname, {path: kmAppPath.site.base})?.params.site;
        return compiler({site: matchedSite});
    };
}
